export const version = 'kunde-v1.20.0-SNAPSHOT-ab56f74496097fa91fea537299412de20a1bd947';